/**
 * The account mails' words (ADR-092 decision 16, moved here by ADR-119 decisions 1 and 3): each mail's subject and
 * its paragraphs. A paragraph is one text and a `\n` in it ends a line of the text part, which wraps at 78
 * characters; the HTML part runs a paragraph's lines together as one run of words. The link is not a word: the
 * template puts it on its own paragraph, or, in the mail that names the game page, which ends the first line of
 * `fix`. `closing` holds the two paragraphs that close every mail. All of it is ADR-092's wording, kept character
 * for character.
 */
export const MAIL = {
  verify: {
    subject: "Confirm your email for OdysseyTales",
    intro: "Welcome to OdysseyTales.",
    linkLead: 'Open this link and press "Confirm email" to confirm that this email address\nis yours:',
    expiry: "The link works once, for 24 hours. You can play without confirming, and you\ncan send a new link from Settings, Account.",
    ignore: "If you did not create this account, ignore this email.",
  },
  reset: {
    subject: "Reset your OdysseyTales password",
    intro: "Someone asked to reset the password of the OdysseyTales account that uses\nthis email address.",
    linkLead: "Open this link to set a new password:",
    expiry: "The link works once, for 30 minutes. After you set a new password, other\ndevices must log in again.",
    ignore: "If you did not ask for this, you can ignore this email. Your password stays\nas it is.",
  },
  changed: {
    subject: "Your OdysseyTales password was changed",
    intro: "The password of the OdysseyTales account that uses this email address was\njust changed. Other devices must log in again with the new password.",
    nothingToDo: "If you changed it, there is nothing to do.",
    fix: 'If you did not, set a new password now: open\nand choose "Forgot password?" on the log in screen.',
  },
  closing: {
    noReply: "Nobody reads this mailbox, so a reply will not reach us.",
    signature: "OdysseyTales",
  },
} as const;
